import {useCallback} from "react";
import {batch, useComputed} from "@preact/signals-react";
import {isEmpty, postSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks"
import {adminProductReviewEditClicked, adminProductReviewLoadingRow, adminProductReviewRawTableData, brandForm, skuForm} from "../@signals";


export default function useAdminProductReviewForm(dataRow={}) {
	const { showToast } = useToast()

	const formData = useComputed(() => {
		if (adminProductReviewRawTableData.value === null) {
			return {}
		}

		return adminProductReviewRawTableData.value.filter(item => item.key === adminProductReviewEditClicked.value)[0] || {}
	})

	const handleSendToBack = useCallback((extraData={}, callback={}) => {
		showToast.promise(postSubmit(`${BACKEND_APIS.ADMIN}/product-review-new/update-mapping`, {
			item: {...dataRow, ...formData.value}, mapping: { ...dataRow, ...extraData}
		}), {
			position: 'top-center',
			...callback
		})
	}, [JSON.stringify(dataRow)])

	const handleUpdate = useCallback(() => {
		const myKey = formData.value.key
		adminProductReviewLoadingRow.value = [...adminProductReviewLoadingRow.value, myKey]
		handleSendToBack({
			...formData.value,
			brandID: brandForm.value || null,
			skuID: Array.isArray(skuForm.value) ? null : skuForm.value,
			qa: true, validated: true, skip: false
		},  {
			onSuccess: newRow => {
				batch(() => {
					adminProductReviewRawTableData.value = [...adminProductReviewRawTableData.value
						.map(row => row.key === myKey ? {
							...newRow, matchedBy: 'QA', validated: true
						} : row)]
					adminProductReviewLoadingRow.value = [...adminProductReviewLoadingRow.value.filter(key => key !== myKey)]
				})
				return 'Data loaded'
			}, onError: () => adminProductReviewLoadingRow.value = [
				...adminProductReviewLoadingRow.value.filter(key => key !== myKey)
			],
		})
	}, [JSON.stringify(dataRow)])

	return {
		showForm: !isEmpty(formData.value),
		formData: formData.value,
		formTitle: formData.value?.productName,

		handleSendToBack,
		handleUpdate
	}
}